import { Component } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LayoutService } from './service/app.layout.service';
import {environment} from "../../environments/environment";
import { MenuNouveautesService } from 'lib-menu-nouveautes';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from '../services/configuration.service';

@Component({
    selector: 'app-rightmenu',
    templateUrl: './app.rightmenu.component.html'
})
export class AppRightMenuComponent {

    selectedAmount!: SelectItem;

    amount = [
        {label: '*****24', value: {id: 1, name: '*****24', code: 'A1'}},
        {label: '*****75', value: {id: 2, name: '*****75', code: 'A2'}}
    ];

    constructor(public layoutService: LayoutService, private nouveauteService : MenuNouveautesService , private translate: TranslateService, private configurationService: ConfigurationService) {
        translate.addLangs(['en', 'fr']);
        translate.setDefaultLang('fr');
    }

    isFullWidth = false;

    toggleFullscreenSidebar()
    {
        this.isFullWidth = !this.isFullWidth;
        console.log(this.isFullWidth);

    }

  configuration = this.configurationService.get();
    get visible(): boolean {
        return this.layoutService.state.rightMenuVisible;
    }

    set visible(_val: boolean) {
        this.layoutService.state.rightMenuVisible = _val;

        //mark as seen when sidebar closes
        if (!_val) {
            this.nouveauteService.markAllAsReadLocally();
            this.isFullWidth = false
        }
    }


}
